import AbstractView from 'abstracts/AbstractView';

import Main from 'controllers/Main';
import Screen from 'controllers/Screen';
import Scroll from 'controllers/Scroll';
import Device from 'controllers/Device';

import MainLoader from 'components/statics/main-loader/js/MainLoader';

import Lazyloader from 'loaders/Lazyloader';

import Utils from 'utils/Utils';


export default class AbstractPage extends AbstractView {


	constructor() {
		super();

		this.E = {
			ASSETS_LOADING_COMPLETE: 'assetsloadingcomplete'
		};

		this.assetsToLoad = null;
	}

	init($wrapper = null, transState) {
		super.init($wrapper, transState);
		this.initSmoothScroll();
	}


	initDOM($wrapper) {
		this.$pageCont = $wrapper;
		this.$content = this.$pageCont.find('.page_content');
	}


	initEl(transState = null) {
		this.transState = transState;
		this.lazyloader = new Lazyloader(this.$pageCont);
	}


	initTl() {
	}


	show(transState = null, delay = 0, isFirstLoad, isSubpage) {
		this.df.show = Utils.Deferred();

		this.playShow(transState, delay, isFirstLoad, isSubpage);

		return this.df.show.promise;
	}


	playShow(transState, delay, isFirstLoad, isSubpage) {
		this.onShowComplete();
	}


	onShowComplete() {
		this.df.show.resolve();
	}


	hide(transState = null, delay = 0, isSubpage) {
		this.df.hide = Utils.Deferred();

		this.playHide(transState, delay, isSubpage);

		return this.df.hide.promise;
	}


	playHide(transState, delay, isSubpage) {
		this.onHideComplete();
	}


	onHideComplete() {
		this.df.hide.resolve();
	}

	initSmoothScroll() {
		Scroll.initSmooth(this.$pageCont[0], this.$content[0]);
	}


	updateSearch() {
		console.log('search updated');
	}


	updateHash() {
		console.log('hash updated');
	}


	destroy() {
		if (this.lazyloader) {
			this.lazyloader.destroy();
		}
		super.destroy();
	}


}

